import assign from 'object-assign';
import RestHelper from '../utils/RestHelper';

const CREATE_FILTERS = 'jobsearch/CREATE_FILTERS';
export const GET_JOBS = 'jobsearch/GET_JOBS';
export const GET_JOBS_ERROR = 'jobsearch/GET_JOBS_ERROR';

const SET_ACTIVE_FILTER = 'jobsearch/SET_ACTIVE_FILTER';
const RESET_ALL_FILTERS = 'jobsearch/RESET_ALL_FILTERS';
const UPDATE_FILTERS = 'jobsearch/UPDATE_FILTERS';
const FILTER_JOBS = 'jobsearch/FILTER_JOBS';
const REMOVE_FILTER = 'jobsearch/REMOVE_FILTER';

const TOGGLE_RESULT_VIEW = 'jobsearch/TOGGLE_RESULT_VIEW';

// Default States

const DEFAULT_FILTERS = [
  {
    selected: []
  },
  {
    selected: []
  },
  {
    selected: []
  },
  {
    selected: []
  }, {
    selected: []
  }
];

const DEFAULT_STATE = {
  jobs: null,
  unfilteredJobs: null,
  jobsCount: null,
  view: {
    dataLoaded: false,
    resultViewType: 'lists',
    errors: false
  },
  activeFilters: DEFAULT_FILTERS,
  filters: [
    { total: null, displayedFilters: null },
    { total: null, displayedFilters: null },
    { total: null, displayedFilters: null },
    { total: null, displayedFilters: null },
    { total: null, displayedFilters: null }
  ]
};

const categoryMap = [
  { name: 'countries', key: 'country' },
  { name: 'locations', key: 'Location' },
  { name: 'divisions', key: 'Division' },
  { name: 'functions', key: 'Function' },
  { name: 'jobtypes', key: 'jobtype' }
];

// Helper functions

const createFilteredJobs = (state, onReset) => {
  const jobsArray = onReset ? state.unfilteredJobs : state.jobs;

  return jobsArray.filter((d) => {
    let countryFiltrMatch = 0;
    if (state.activeFilters[0].selected) {
      for (let index = 0; index < state.activeFilters[0].selected.length; index += 1) {
        if (d.jobRecord[0].country.indexOf(state.activeFilters[0].selected[index]) !== -1) {
          countryFiltrMatch = 1;
          break;
        }
      }
    }

    let locationFiltrMatch = 0;
    if (state.activeFilters[1].selected) {
      for (let index2 = 0; index2 < state.activeFilters[1].selected.length; index2 += 1) {
        if (d.jobRecord[0].Location.indexOf(state.activeFilters[1].selected[index2]) !== -1) {
          locationFiltrMatch = 1;
          break;
        }
      }
    }

    let divisionFiltrMatch = 0;
    if (state.activeFilters[2].selected) {
      for (let index3 = 0; index3 < state.activeFilters[2].selected.length; index3 += 1) {
        if (d.jobRecord[0].Division.indexOf(state.activeFilters[2].selected[index3]) !== -1) {
          divisionFiltrMatch = 1;
          break;
        }
      }
    }

    let functionFiltrMatch = 0;
    if (state.activeFilters[3].selected) {
      for (let index4 = 0; index4 < state.activeFilters[3].selected.length; index4 += 1) {
        if (d.jobRecord[0].Function.indexOf(state.activeFilters[3].selected[index4]) !== -1) {
          functionFiltrMatch = 1;
          break;
        }
      }
    }

    let jobtypeFiltrMatch = 0;
    if (state.activeFilters[4].selected) {
      for (let index5 = 0; index5 < state.activeFilters[4].selected.length; index5 += 1) {
        if (d.jobRecord[0].jobtype.indexOf(state.activeFilters[4].selected[index5]) !== -1) {
          jobtypeFiltrMatch = 1;
          break;
        }
      }
    }

    return (
      (state.activeFilters[0].selected.length < 1 || countryFiltrMatch) &&
      (state.activeFilters[1].selected.length < 1 || locationFiltrMatch) &&
      (state.activeFilters[2].selected.length < 1 || divisionFiltrMatch) &&
      (state.activeFilters[3].selected.length < 1 || functionFiltrMatch) &&
      (state.activeFilters[4].selected.length < 1 || jobtypeFiltrMatch)
    );
  });
};

const getPossibleFilters = (categories, state, filterIndex, onReset) => {
  const jobsArray = onReset ? state.unfilteredJobs : state.jobs;
  let possibleFilters = [];
  categories.forEach((category, index) => {
    let catFiltered;
    catFiltered = jobsArray.map(job => job.jobRecord[0][category.key]);

    let counted = {};
    catFiltered.forEach((i) => {
      counted[i] = (counted[i] || 0) + 1;
      return null;
    });

    possibleFilters[index] = {
      total: catFiltered.length,
      displayedFilters: counted
    };

    if (possibleFilters[filterIndex]) {
      possibleFilters[filterIndex].catTotal = state.filters[filterIndex].total;
    }
  });
  return possibleFilters;
};

// Action Creators
export const getJobsFromAPI = (dispatch, jobsEndpoint) => {
  return RestHelper
    .get(jobsEndpoint)
    .then((response) => {
      dispatch({
        type: GET_JOBS,
        data: {
          jobs: response.data.jobData[0].De,
          unfilteredJobs: response.data
        }
      });
    }).catch((err) => {
      console.error(err); // eslint-disable-line no-console
      return dispatch({
        type: GET_JOBS_ERROR,
        data: {
          error: err
        }
      });
    });
};

export function createFilters(filterCategory, catIndex, filters, filterTotal) {
  return {
    type: CREATE_FILTERS,
    filterCategory,
    catIndex,
    filters,
    filterTotal
  };
}

export function setFilter(filterIndex, filterValue) {
  return (dispatch, getState) => {
    if (getState().jobSearchReducer.activeFilters[filterIndex].selected.indexOf(filterValue) === -1) {
      dispatch({
        type: SET_ACTIVE_FILTER,
        filterIndex,
        filterValue
      });

      dispatch({
        type: FILTER_JOBS,
        onReset: false
      });

      return dispatch({
        type: UPDATE_FILTERS,
        categories: categoryMap,
        filterIndex,
        onReset: false
      });
    }

    return false;
  };
}

export function resetFilter() {
  return (dispatch) => {
    dispatch({
      type: RESET_ALL_FILTERS
    });

    dispatch({
      type: FILTER_JOBS,
      onReset: true
    });

    return dispatch({
      type: UPDATE_FILTERS,
      categories: categoryMap,
      onReset: true
    });
  };
}

export function toggleResultview(view) {
  return {
    type: TOGGLE_RESULT_VIEW,
    viewType: view
  };
}

function composeFilter(action, filters) {
  const newFilter = assign([], filters);

  newFilter[action.catIndex] = {
    total: action.filterTotal,
    displayedFilters: {
      ...action.filters
    }
  };
  return { filters: newFilter };
}

function composeSelectedFilter(action, activeFilters) {
  const newFilter = assign([], activeFilters);
  if (action.filterValue instanceof Array) {
    newFilter[action.filterIndex] = {
      selected: action.filterValue
    };
  } else {
    newFilter[action.filterIndex] = {
      selected: [action.filterValue]
    };
  }
  return { activeFilters: newFilter };
}


// Reducers
export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case GET_JOBS:
      return assign({}, state, {
        unfilteredJobs: action.data.jobs,
        jobs: action.data.jobs,
        jobsCount: action.data.unfilteredJobs.jobData[0].JobsCount,
        view: {
          ...state.view,
          dataLoaded: true
        }
      });

    case GET_JOBS_ERROR:
      return assign({}, state, {
        view: {
          ...state.view,
          errors: action.data.error
        }
      });

    case CREATE_FILTERS:
      return assign({}, state, composeFilter(action, state.filters));

    case SET_ACTIVE_FILTER:
      return assign({}, state, composeSelectedFilter(action, state.activeFilters));

    case FILTER_JOBS:
      return {
        ...state,
        jobs: createFilteredJobs(state, action.onReset)
      };

    case UPDATE_FILTERS:
      return assign({}, state, { filters: getPossibleFilters(action.categories, state, action.filterIndex, action.onReset) });


    case RESET_ALL_FILTERS:
      return assign({}, state, { activeFilters: DEFAULT_FILTERS });

    case REMOVE_FILTER:
      return {
        ...state,
        activeFilters: {
          ...state.filters.activeFilters,
          [action.filterGroup]: []
        }
      };

    case TOGGLE_RESULT_VIEW:
      return assign({}, state, {
        view: {
          ...state.view,
          resultViewType: action.viewType
        }
      });

    default: return state;
  }
}
